import Container from "@components/shared/Container";
import Card from "@components/shared/Card";

import AddParticipantForm from "@components/form/participant/AddParticipantForm";
import ParticipantsTable from "@components/stat/participant/table/ParticipantsTable";

const ParticipantsTab: React.FC = () => (
  <Container title="Управление участниками">
    <Card title="Добавить участника">
      <AddParticipantForm />
    </Card>
    <Card>
      <ParticipantsTable />
    </Card>
  </Container>
);

export default ParticipantsTab;
